import React, { useEffect, useMemo, useState } from 'react'
import { Modal, ModalFooter, ModalHeader, Button } from "reactstrap"
import Cargando from 'components/Varios/Cargando'
import ButtonAceptar from 'components/Varios/Modals/ButtonAceptar'
import IconCloseModal from 'components/Varios/Modals/IconCloseModal'
import { State } from 'react-svg'
import PDFViewer from '../PDFViewer'
import PDFViewerBrowser from '../PdfViewerBrowser'
import { ModalBody } from 'react-bootstrap'



type PropsModalVerDocumentoPDF = {
    show: boolean,
    urlArchivo: string,
    size: "xl" | "sm" | "md" | "lg",
    onClose: () => void,
    cargandoDatos: boolean,
    disabledbuttonCondition?: boolean,
    tituloModal: string,
    accionOnAccept: boolean,
    asyncAccion?: (args?: any) => Promise<void>
    closeAfterAsync?:boolean,
    onAccion?: (args?: any) => void
    botonCerrar?: boolean,
    nombreBotonAccion?: string
    modalContent?: any
    enableDownload?:boolean
    zoomDefaultValue?:number
}

type StateModalVerDocumentosAccion = {
    cargando: boolean,
    error: boolean,
}

export default function ModalVistaPreviaDocumentosAccion(props: PropsModalVerDocumentoPDF) {

    const defaultStateModal: StateModalVerDocumentosAccion = {
        cargando: false,
        error: false
    }

    const [stateModal, setStateModal] = useState<StateModalVerDocumentosAccion>(defaultStateModal)

    function CerrarModal() {
        props.onClose();
        document.body.classList.remove('modal-open')
    }

    const ContenidoModalBody = useMemo(() => {
        if (props.cargandoDatos || stateModal.cargando) {
            return (
                <Cargando />
            )
        }
        else if (!props.cargandoDatos && props.urlArchivo !== "") {
            return (
                <>
                    {props.modalContent}

                    {props.enableDownload !== undefined && props.enableDownload === true &&
                        <div style={{ overflowX: "auto" }} className="row text-center mb-3">
                            <object data={props.urlArchivo}
                                type="application/pdf"
                                width="100%"
                                height={"445"}

                            />
                        </div>
                    }

                    {!props.enableDownload && !props.zoomDefaultValue &&
                        <PDFViewer url={props.urlArchivo} heightValue={"90%"} />
                    }
                    {
                        !props.enableDownload && props.zoomDefaultValue &&
                        <PDFViewer url={props.urlArchivo} heightValue={"90%"}  zoomDefaultValue={props.zoomDefaultValue}/>
                    }

                </>

            )
        }
        else {
            return (
                <div>
                    No hay contenido por mostrar
                </div>
            )
        }
    }, [props.urlArchivo, props.cargandoDatos, stateModal.cargando])

    const BotonCerrar = useMemo(() => {
        return (
            <IconCloseModal
                handleClickIcon={() =>CerrarModal()}
            />
        )
    }
        , [props])

    async function HandleAceptar() {
        const { onClose, accionOnAccept, asyncAccion,closeAfterAsync } = props;
        if (accionOnAccept && typeof (props.asyncAccion) === "function") {
            setStateModal({ cargando: true, error: false })
            await props.asyncAccion();
            setStateModal({ cargando: false, error: false })
            if(closeAfterAsync !== undefined && closeAfterAsync === true){
                CerrarModal()
            }
            CerrarModal()

        } else if (accionOnAccept && typeof (props.onAccion) === "function"){
            setStateModal({ cargando: true, error: false })
            await props.onAccion();
            setStateModal({ cargando: false, error: false })
            CerrarModal()
        }
        else {
            CerrarModal()
        }
    }

    const Ontoggle = () => {props.onClose();document.body.classList.remove('modal-open');}

    return (
        <Modal
            isOpen={props.show}
            scrollable={true}
            size={props.size}
            fullscreen={props.size}
            centered={true}
            onClosed={() => props.onClose()}
            toggle = {Ontoggle}
        // contentClassName="custom-modal-style"
        >
            <ModalHeader close={BotonCerrar}>
                <div className='tituloModalDocumentos'>{props.tituloModal}</div>
            </ModalHeader>
            <ModalBody>
                {ContenidoModalBody}
            </ModalBody>
            <ModalFooter>
                {
                    props.accionOnAccept &&
                    <Button 
                    className={"button-cancelar"}
                    color="secondary" onClick={() => props.onClose()}>{"Cancelar"}
                    </Button>

                }
                <ButtonAceptar
                    nombreBoton={props.nombreBotonAccion}
                    handleClickAceptar={() => HandleAceptar()}
                    className={"button-aceptar"}
                    disabledButton={props.disabledbuttonCondition || stateModal.cargando}
                />
                
            </ModalFooter>
        </Modal>

    )



}
